import { getLink, trans } from "~/providers/lang";
import GalleryEnter from "~/components/GalleryEnter";
import { ROUTES, GALLERY_PREVIEW_LARGE_COUNT } from '~/const';
import { mainStore } from "~/stores/main";
import { useSeo } from "~/hooks/useSeo";

import "./style.less";

export default function SchoolWeddingPage() {
	useSeo({
		title: trans("skelet.title.schoolWedding"),
		canonical: "poloneza",
	});

	const pageData = mainStore(state => state.data.pageData);
	const items = pageData.photos.schoolWedding[0].slice(0, GALLERY_PREVIEW_LARGE_COUNT);

	return <>
		<div className="body-background">
			<div className="school-wedding-page page-content top-shadow">
				<h1 className="other-page-title">
					{trans('schoolWedding.title')}
				</h1>
				<div className="row">
					<div className="col-md-12">
						<p className="desc" dangerouslySetInnerHTML={{ __html: trans('schoolWedding.desc') }} />
					</div>
				</div>
				<GalleryEnter link={getLink(ROUTES.gallerySchoolWedding)} items={items} />
				<div className="school-wedding-img-cont school-formal-voucher">
					<img src="/img/poloneza-poukaz.jpg?2" alt="{myFunctions:trans('schoolWedding.voucher')}" className="promo-img" />
				</div>
			</div>
		</div>
	</>;
}
